import { render, staticRenderFns } from "./SocialMediaPageSelection.vue?vue&type=template&id=13818ce8&scoped=true&"
import script from "./SocialMediaPageSelection.vue?vue&type=script&lang=js&"
export * from "./SocialMediaPageSelection.vue?vue&type=script&lang=js&"
import style0 from "./SocialMediaPageSelection.vue?vue&type=style&index=0&id=13818ce8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13818ce8",
  null
  
)

export default component.exports